/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Day_Empty_BodyInputs */

const en_us2_plan_build_day_empty_body = /** @type {(inputs: Plan_Build_Day_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick exercises from the catalogue, with search and filters, or ask your trainer what makes sense for this day.`)
};

const pt_br2_plan_build_day_empty_body = /** @type {(inputs: Plan_Build_Day_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha os exercícios no catálogo, com busca e filtros, ou peça ao personal o que faz sentido para este dia.`)
};

const es_419_plan_build_day_empty_body = /** @type {(inputs: Plan_Build_Day_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige ejercicios del catálogo, con búsqueda y filtros, o pregúntale a tu entrenador qué tiene sentido para este día.`)
};

const pt_pt2_plan_build_day_empty_body = /** @type {(inputs: Plan_Build_Day_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolhe os exercícios no catálogo, com pesquisa e filtros, ou pergunta ao treinador o que faz sentido para este dia.`)
};

const fr_fr2_plan_build_day_empty_body = /** @type {(inputs: Plan_Build_Day_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisis des exercices dans le catalogue, avec recherche et filtres, ou demande à ton coach ce qui a du sens pour ce jour.`)
};

const de_de2_plan_build_day_empty_body = /** @type {(inputs: Plan_Build_Day_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähl Übungen aus dem Katalog, mit Suche und Filtern, oder frag deinen Coach, was an diesem Tag sinnvoll ist.`)
};

const it_it2_plan_build_day_empty_body = /** @type {(inputs: Plan_Build_Day_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli gli esercizi dal catalogo, con ricerca e filtri, oppure chiedi al coach cosa ha senso per questo giorno.`)
};

/**
* | output |
* | --- |
* | "Pick exercises from the catalogue, with search and filters, or ask your trainer what makes sense for this day." |
*
* @param {Plan_Build_Day_Empty_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_day_empty_body = /** @type {((inputs?: Plan_Build_Day_Empty_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Day_Empty_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_day_empty_body(inputs)
	if (locale === "es-419") return es_419_plan_build_day_empty_body(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_day_empty_body(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_day_empty_body(inputs)
	if (locale === "de-DE") return de_de2_plan_build_day_empty_body(inputs)
	if (locale === "it-IT") return it_it2_plan_build_day_empty_body(inputs)
	return en_us2_plan_build_day_empty_body(inputs)
});
export { plan_build_day_empty_body as "plan-build.day_empty_body" }